module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"title":"Новини"}}')
  delete Component.options._Ctor
}
